module.exports = function(service) {
	'use strict'
	service.factory('eventStream',eventStream);
	eventStream.$inject=['config','$rootScope','$timeout','getConfigData'];
	function eventStream(config, $rootScope, $timeout, getConfigData) {
		
		var eventStreamService = {
			connections: {}, // Store multiple connections by name
			
			// Connect to EventSource with custom URL
			connect: function(connectionName, url, options) {
				// Don't connect if already connected
				if (this.connections[connectionName]) {
					return;
				}
				
				options = options || {};
				
				// Store connection info
				this.connections[connectionName] = {
					name: connectionName,
					url: url,
					connection: null,
					connected: false,
					messageHandlers: [],
					options: options
				};
				
				this._createConnection(connectionName);
			},
			
			// Create the actual EventSource connection
			_createConnection: function(connectionName) {
				var connection = this.connections[connectionName];
				if (!connection) return;

				try {
					// Create EventSource without authentication
					connection.connection = new EventSource(connection.url);
					this._setupEventHandlers(connectionName);
				} catch (error) {
					console.log(error);
				}
			},
			
			// Setup event handlers for a connection
			_setupEventHandlers: function(connectionName) {
				var self = this;
				var connection = this.connections[connectionName];
				if (!connection) return;
				// Connection opened
				connection.connection.onopen = function(event) {
					connection.connected = true;
					$rootScope.$apply(function() {
						$rootScope.eventStreamError = false;
					});	
					// // Emit connection event
					// $rootScope.$emit('eventStream:connected', { 
					// 	connectionName: connectionName,
					// 	url: connection.url 
					// });
				};
				
				// Message received
				connection.connection.onmessage = function(event) {
					try {
						var data = JSON.parse(event.data);
						self._handleMessage(connectionName, data);
					} catch (error) {
						
					}
				};
				
				// Error occurred
				connection.connection.onerror = function(event) {
					connection.connected = false;
					// If connection is closed (redyState === 2) 
					// 1. because of server error we createConnection again (reconnect)
					// 2. if is intentionaly disconnect and close connection, createConnection will return because there will not be this this.connections[connectionName]
					// if (readyState === 0) we are not connected to server (internet connection lost) and eventSource reconnect automatically
					if(connection.connection.readyState === 2) {
						$timeout(function() {
							connection.connection.close();
							connection.connection = null;
							self._createConnection(connectionName);
						}, 2000);
					}
		
					$rootScope.$apply(function() {
						$rootScope.eventStreamError = true;
						// get fresh config data for focus connection
						if(connection.name == 'focus') {
							getConfigData.getData('focus_stream');
						}
					});
				};
			},
			
			// Handle incoming messages for a connection
			_handleMessage: function(connectionName, data) {
				var connection = this.connections[connectionName];
				if (!connection) return;
				
				// Call all registered message handlers for this connection
				connection.messageHandlers.forEach(function(handler) {
					try {
						handler(data, connectionName);
					} catch (error) {
						
					}
				});
				
				// // Emit message event for backward compatibility
				// $rootScope.$emit('eventStream:message', { 
				// 	connectionName: connectionName,
				// 	data: data 
				// });
			},
			

			
			// Disconnect from a specific connection
			disconnect: function(connectionName) {
				var connection = this.connections[connectionName];
				
				if (connection && connection.connection) {
					connection.connection.close();
					delete this.connections[connectionName];
					
				}
			},
			
			// Disconnect from all connections
			disconnectAll: function() {
				var self = this;
				Object.keys(this.connections).forEach(function(connectionName) {
					self.disconnect(connectionName);
				});
			},
			
			// Add message handler for a specific connection
			onMessage: function(connectionName, handler) {
				var connection = this.connections[connectionName];
				if (connection && typeof handler === 'function') {
					connection.messageHandlers.push(handler);
				}
			},
			
			// Remove message handler for a specific connection
			offMessage: function(connectionName, handler) {
				var connection = this.connections[connectionName];
				if (connection) {
					var index = connection.messageHandlers.indexOf(handler);
					if (index > -1) {
						connection.messageHandlers.splice(index, 1);
					}
				}
			},
			hasMessageHandler: function(connectionName, handler) {
				var connection = this.connections[connectionName];
				if (connection) {
					return connection.messageHandlers.includes(handler);
				}
				return false;
			},
			// Get connection status
			getConnectionStatus: function(connectionName) {
				var connection = this.connections[connectionName];
				return connection ? {
					connected: connection.connected,
					url: connection.url
				} : null;
			},
			
			// Check if a connection is connected
			isConnected: function(connectionName) {
				var connection = this.connections[connectionName];
				return connection ? connection.connected : false;
			},
			
			// Get all connection names
			getConnectionNames: function() {
				return Object.keys(this.connections);
			},
			getConnection: function(connectionName) {
				return this.connections[connectionName];
			},
			
		};
		
		// Cleanup on page unload
		window.addEventListener('beforeunload', function() {
			eventStreamService.disconnectAll();
		});
		
		return eventStreamService;
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/eventStreamService.js
// module id = 602
// module chunks = 0